export default __webpack_public_path__ + "static/default_practice_area_banner-51a47d4db21a9a8992819ff9b3cba68c.jpg";